<h3 mat-dialog-title i18n>Open Project</h3>
  <mat-dialog-content>
      <mat-form-field>
          <input type="text" placeholder="Project Nr." aria-label="Number" matInput [formControl]="projectNr" maxlength="6" i18n-placeholder>
          <mat-error *ngIf="projectNr.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field>
          <input type="number" placeholder="Total Value" aria-label="Number" matInput [formControl]="totalValue" i18n-placeholder>
      </mat-form-field>
      <app-user-picker placeholder="Project Manager" [myControl]="projectManager"></app-user-picker>
      <mat-form-field>
        <mat-select placeholder="Payment Method" [formControl]="paymentMethod">
          <mat-option *ngFor="let pm of paymentMethodOptions" [value]="pm.methodValue">
            {{ pm.methodValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Delivery Date" [min]="minDeliveryDate" [matDatepicker]="deliveryFormDate" [formControl]="deliveryDate">
        <mat-datepicker-toggle matSuffix [for]="deliveryFormDate"></mat-datepicker-toggle>
        <mat-datepicker #deliveryFormDate></mat-datepicker>
      </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
          <button type="submit" mat-button (click)="closeDialog()" [disabled]="!isValid" i18n>Submit</button>
  </mat-dialog-actions>
  


// WEBPACK FOOTER //
// ./src/app/budget/budget-detail.component.ts.OpenProjectDialogComponent.html